// COMPONENT primarily utilises GREENBUTTON.jsx

// TODO: Some of the logic here is not very maintainable.
// The behaviour input from the parent via the awaitActivePrerequesites prop adds complexity
// and so does the requirement that the button support both an icon-only version and a text version
// Can we simplify this, or should we split this component into two components?

// DownloadButton
  // DownloadButton can be used in any situation where a download needs to occur on button-press
  // The component will check the user's profile on the production DB to check the status of the warndlsecurity flag
  // and if necessary will display a popup (DownloadDialog.jsx) featuring the filename and a warning to securely store and transmit any files
  // downloaded. This popup has the option for the user to opt-out of future download warnings.

// Usage
  // PROPS
    // downloadParams
      // The parent component of DownloadButton should contain a function that returns url and filename for the download, in the format
      // {'url': url, 'filename':filename, 'status': status}
      // This will allow DownloadButton to action the download
      // Also allows download button to show data about the response (eg, display an error for non-200 responses)
    // userDetails
      // and should pass userDetails on to DownloadButton as the same 'userDetails' prop
      // userDetails is a prop that originates in App.js, and contains data about the user pulled from the DB. It allows us to 
      // get and set the warndlsecurity flag for the user.
    // buttonText
      // Text on the button
    // dlButtonType
      // If 'icon': show only the download icon, with a transparent background and limited button size
      // Otherwise if left blank, show a green button with text and icon
    // awaitActivePrerequisites
      // Using a awaitActivePrerequisites prop in the parent will allow the parent to control the awaitActivePrerequisites true/false state of the button
      // This is useful if the parent needs to control the button's status (eg, set a loading state to indicate that information is being
      // generated for the button, and it cannot be used until this info is generated)
      // NOT using a awaitActivePrerequisites prop in the parent allows this button to await the return of downloadParams before
      // activating the button, using awaitActivePrerequisites styling in the meantime
    // Disabling the non-dialog-box download button until download is actioned
      // When the download warning dialogue box pops up, the download button on the page (not the one in the dialogue box) clickable area becomes full screen
      // Why? Who knows.
      // This can result in some issues. So there is logic here to disable the on-page download button until the dialogue box download button has been clicked.
      // Not doing this can result in the download dialogue box logic repeating itself when the dialogue box is closed.


import React, { useContext, useEffect, useState } from 'react';
import {createPortal} from 'react-dom';

import { 
  Button,
  CircularProgress,
  LinearProgress,
  Tooltip,
  Typography
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ErrorIcon from '@mui/icons-material/Error';

import UserContext from '../../contexts/UserContext';

import DownloadDialog from '../dialog/DownloadDialog';

// Global variables
let downloadParameters = {'filename': null};
// In milliseconds
let minimumLoadingAnimationDuration = 1000;
let filename;
let url;
let status;


export default function DownloadButton(props) {
  const { downloadParams, buttonText, setButtonText, defaultButtonText, iconOnly, style, awaitActivePrerequisites, setAwaitActivePrerequisites, forceDisabled} = props
  const { konsolUser } = useContext(UserContext)
  ///////////// STATE
  // State to manage whether the button is ready for clicking
  const [isWaiting, setIsWaiting] = useState(awaitActivePrerequisites)
  const [downloadError, setDownloadError] = useState(false)
  const [downloadErrorText, setDownloadErrorText] = useState('')
  const [iconButtonDisabled, setIconButtonDisabled] = useState(false)



  // const [downloadParameters, setDownloadParameters] = useState({})
  


  // The isWaiting state can be controlled by the parent component (eg, set state to 'awaitActivePrerequisites' until the user
  //   has clicked a button to generate the downloadable files)
  // The isWaiting state can alternatively be controlled by this component (eg, set state to 'awaitActivePrerequisites' until the
  //   parent component's downloadParams returns the required information. Useful for if clicking the
  //   download button itself triggers the generation of downloadable files.
  // vvv
  // On every render of the component, check to see IF awaitActivePrerequisites prop has been set by the parent, 
  //   On every render of this component, set the 'isWaiting' state to match the 'awaitActivePrerequisites' prop as set
  //   by the parent component. The parent component can manage whether the download button
  //   should wait for a condition to be met (eg, files are ready to download)
  //   Only do this if  awaitActivePrerequisites has been set by the parent
  // OTHERWISE isWaiting can be managed by this button
  if (awaitActivePrerequisites !== undefined){
    if (isWaiting !== awaitActivePrerequisites) {
      setIsWaiting(awaitActivePrerequisites);
      // If awaitActivePrerequisites is true (we are generating new files)
      // Clear any error states
      if (awaitActivePrerequisites == true){
        setDownloadError(false)
        setIconButtonDisabled(false)
      }
    }
  }

  

  useEffect(()=>{
    setIconButtonDisabled(forceDisabled)
  },[forceDisabled])



  ////////// STYLING
  // Styling and visuals
  let bgColor;
  let disableDropShadow = false;
  // Styling if we have an icon-only dl button
  if (iconOnly != undefined){
    if (iconOnly == true){
      
      bgColor = 'rgba(0,0,0,0)';
      disableDropShadow = true;
    }
    else {
      bgColor = 'green'
    }
  }


  const baseStyle = {
    paddingLeft:'20px',
    paddingRight:'20px',
    backgroundColor: bgColor,
    color: 'white',
    textTransform: 'none',
    fontWeight: 'bold',
    outline: 'none',
    ...style
  };

  let iconOnlyStyle = {
    borderRadius: '50%',
    // overwrite <Button>'s default min dimensions
    minHeight: '64px',
    minWidth: '64px',
    height: '64px',
    width: '64px',
    backgroundColor: 'transparent',
    outline: 'none',
    ...style
}

  const waitingStyle = {
    backgroundColor: 'rgba(107, 164, 125, 0.2)',
    color: 'green',
    textTransform: 'none',
    fontWeight: 'bold',
    outline: '1px solid green',
    ...style
  }
  const errorStyle = {
    backgroundColor: 'darkred'
  }

  // Final style mixer
  // Styles lower in each 'finalStyle' list will override those higher in list
  let finalStyle;
  if (isWaiting && iconOnly){
    finalStyle = {
      ...baseStyle,
      ...waitingStyle,
      ...iconOnlyStyle,
    }
  }else if (isWaiting){
    finalStyle = {
      ...baseStyle,
      ...waitingStyle
    }
  }else if (iconOnly){
    finalStyle = {
      ...baseStyle,
      ...iconOnlyStyle
    }
  }else if (iconOnly == false && downloadError){
    finalStyle = {
      ...baseStyle,
      ...errorStyle
    }
  }else{
    finalStyle = baseStyle
  }

  let downloadButtonIcon = {
    transition: '0.4s',
    opacity: isWaiting ? '0' : '1',
    width: isWaiting ? '0px' : '20px'
  }
  


  ////////////// LOGIC

  // Download Dialog box interaction and visibility handlers
  const [openDownloadDialog, setOpenDownloadDialog] = useState(false)

  const clickAway = () => {
      setOpenDownloadDialog(false)
      setIconButtonDisabled(false)
      if (defaultButtonText != undefined){
        setButtonText(defaultButtonText)
      }
      if (setAwaitActivePrerequisites != undefined){
        setAwaitActivePrerequisites(false)
      }
      
  }

  // Check if the user should be warned about download security
  //   If they have opted-out of the warning, they will have a warndlsecurity property in their userDetails, and it will be set to false
  async function buttonClick(){
    if (downloadError) {
      setDownloadError(false)
      setDownloadErrorText('')
      if (setButtonText != undefined){
        setButtonText('')
      }
    }else{
      setIsWaiting(true)
      setIconButtonDisabled(true)
      
      if (setAwaitActivePrerequisites != undefined){
        setAwaitActivePrerequisites(true)
      }
      if (defaultButtonText != undefined){
        setButtonText('Preparing files')
      }
      // Show the warning popup (or don't), then proceed
      handleDL()
    }

    
  }


  async function handleDL(){
    // Begin timer to ensure loading animation plays for a minimum time to avoid it looking buggy
    let startTime = new Date();

    // Wait for the parent's downloadParams() function to return information about the file
    // that we want to download
    // Set global variable downloadParameters
    downloadParameters = await downloadParams()

    // Get download info and download status. Assign to global variables
    filename = downloadParameters['filename']
    url = downloadParameters['url']
    status = downloadParameters['status']

    // Check if the URL we have above points to a file that is available for download. If not, show error
    // 'status' it not a required prop, however ommitting it will disable error display
    if (status == '200' || status==undefined){
      // Do we need to show the download security warning?
      // If they have no warndlsecurity property, show the warning
      if(konsolUser?.user_metadata?.warndlsecurity ?? true){
        setIconButtonDisabled(true)
        // Show download warning page
        setOpenDownloadDialog(true)
      }
      else{
        downloadClick()
      }
    }
    // else if the status of our download is not 200...
    else{
      setDownloadError(true)
      if (status == '404'){
        if (iconOnly == true){
          setDownloadErrorText('File not found')
        }
        if (setButtonText != undefined){
          setButtonText('File not found')
        }
      }else{
        if (iconOnly == true){
          setDownloadErrorText('Unspecified download error')
        }
        if (setButtonText != undefined){
          setButtonText('Unspecified download error')
        }
      }
    }

    let endTime = new Date();
    if (endTime.getTime() - startTime.getTime() < minimumLoadingAnimationDuration){
      let waitTime = minimumLoadingAnimationDuration - (endTime.getTime() - startTime.getTime());
      setTimeout(()=>{setIsWaiting(false)}, waitTime)
    } else {
      setIsWaiting(false)
    }

    if (setAwaitActivePrerequisites != undefined){
      setAwaitActivePrerequisites(false)
    }
  }

  async function downloadClick(){
    setIconButtonDisabled(false);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
      // Download button clicked - reenable button
      setIconButtonDisabled(false)
      if (defaultButtonText != undefined){
        setButtonText(defaultButtonText)
      } 
  }



  return (
  <Tooltip title={downloadErrorText}
          placement='left'  
          arrow 
          PopperProps={{style:{zIndex:0}}}
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: "red",
                color: "white",
                zIndex: 0
              }
            },
            arrow: {
              sx: {
                color: "red"
              }
            }
          }}    
    >
      <span>
      <Button
        onClick={buttonClick}
        // disableDropShadow = {disableDropShadow}
        style={finalStyle}
        disabled={iconButtonDisabled}
      >
          {iconOnly == false && downloadError == false && 
            <>
              <Typography>{buttonText}</Typography> 
              <DownloadIcon style={downloadButtonIcon}/>
            </>
          }

          {iconOnly == false && downloadError && 
              <Typography>{buttonText}</Typography> 
          } 

          {downloadError == false && iconOnly &&
            <DownloadIcon style={downloadButtonIcon}/>
          }
          
          {isWaiting && iconOnly && (
              <CircularProgress
                size={45}
                sx={{
                  color: 'green',
                  position: 'absolute',
                  zIndex: 1,
                }}
              />
          )}
          {isWaiting && iconOnly==false && (
            <LinearProgress 
              color="success"
              sx={{
                position: 'absolute',
                height: '100%',
                width: '100%',
                opacity: '0.2',
                zIndex: 100
              }}
            />
          )}
          {downloadError && iconOnly && (
                <ErrorIcon color='error'></ErrorIcon>
          )}
  
        {/* DOWNLOAD DIALOG POPUP */}
        {/* createPortal allows us to display the warning popup within another element (document.body)
        so we can keep as much of the download logic within this component as possible */}
        {createPortal(
              <DownloadDialog 
                open={openDownloadDialog} 
                filename={downloadParameters['filename']}
                downloadClick={downloadClick}
                clickAway={clickAway} 
                parentIconButtonDisabled = {iconButtonDisabled}
                setParentIconButtonDisabled = {setIconButtonDisabled}
              />
              ,document.body
          )}
  
      </Button>
      </span>
    </Tooltip>
  );
}